"use client";

import { PanelLeft } from "lucide-react";
import Image from "next/image";
import { IntentPrefetchLink } from "@/components/navigation/IntentPrefetchLink";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { strings } from "@/content/strings";
import { routes } from "@/lib/routes";

export function MobileNavigation() {
  const { openMobile, toggleSidebar } = useSidebar();

  return (
    <header className="mb-6 flex items-center justify-between gap-4 md:hidden">
      <IntentPrefetchLink href={routes.system()}>
        <Image
          src="/brand/logo.png"
          alt={strings.appName}
          width={128}
          height={40}
          priority
        />
      </IntentPrefetchLink>
      <Button
        type="button"
        variant="outline"
        size="icon"
        aria-label={strings.ui.sidebar.toggle}
        aria-expanded={openMobile}
        onClick={toggleSidebar}
      >
        <PanelLeft aria-hidden />
      </Button>
    </header>
  );
}
